module.exports = __webpack_public_path__ + "img/签到.3c046bb4.png";